import {
  SET_STATE_ANSWERS,
  CLEAR_STATE_ANSWERS,
  SET_ADDITIONAL_ANSWERS,
  SET_EXTRA_ANSWER,
} from "./constants";

export const GUIDES_INITIAL_STATE = {
  answers: {},
};

function guideReducer(state = GUIDES_INITIAL_STATE, action: any) {
  switch (action.type) {
    case SET_STATE_ANSWERS: {
      return {
        ...state,
        answers: { ...action.value },
      };
    }
    case SET_ADDITIONAL_ANSWERS: {
      return {
        ...state,
        additionalAnswers: { ...action.value },
      };
    }
    case SET_EXTRA_ANSWER: {
      return {
        ...state,
        extraAnswer: { ...action.value },
      };
    }
    case CLEAR_STATE_ANSWERS: {
      return { ...GUIDES_INITIAL_STATE };
    }
    default:
      return state;
  }
}

export default guideReducer;
